import React, { useState, useEffect } from "react";
import "./styles.css";
import Weather from "./Weather/Weather";

function App() {
  const [city, setCity] = useState("");
  const [currentDate, setCurrentDate] = useState("");

  const handleCityChange = (event) => {
    setCity(event.target.value);
  };

  useEffect(() => {
    updateCurrentDate();

    const intervalId = setInterval(updateCurrentDate, 60000);

    return () => clearInterval(intervalId);
  }, []);

  const updateCurrentDate = () => {
    const now = new Date();
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const formattedDate = now.toLocaleDateString("en-US", options);
    setCurrentDate(formattedDate);
  };

  return (
    <div className="App">
      <h1>Daily Forecast</h1>
      <div className="search-container">
        <input
          type="text"
          id="cityInput"
          placeholder="Enter city"
          value={city}
          onChange={handleCityChange}
        />
        <button className="clear-button" onClick={() => setCity("")}>
          Clear
        </button>
      </div>
      <div className="current-date">{currentDate}</div>
      <Weather city={city} />
    </div>
  );
}

export default App;
